(ns shared.core.amelia-light.components.theme
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]))

(defn cur-theme [db]
  (let [theme (:theme (:local-storage db))]
    (if (:system theme)
      (if (util/dark-mode-system-setting?)
        (:dark theme)
        (:light theme))
      theme)))

(re/reg-sub :alc/theme- cur-theme)

(re/reg-event-fx
  :alc/set-theme re/middleware
  (fn [{:keys [local-storage]} [new-theme]]
    (re/dispatch [:alc/set-app-data-theme])
    {:local-storage (assoc local-storage :theme new-theme)}))

(re/reg-event-db
  :alc/set-app-data-theme
  (fn [db]
    (let [current-theme (cur-theme db)]
      (when-let [root-el (.getElementById js/document "app")]
        (if current-theme
          (.setAttribute root-el "data-theme" (name current-theme))
          (.removeAttribute root-el "data-theme")))
      db)))
